var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Tooltip as BaseTooltip, Pressable } from "native-base";
const ToolTip = (_a) => {
    var { variant = "dark", children, isRenderable = true } = _a, rest = __rest(_a, ["variant", "children", "isRenderable"]);
    const [isOpen, setOpen] = useState(false);
    const variants = useMemo(() => ({
        primary: {
            bgColor: "green.600",
            _text: {
                color: "white",
            },
        },
        dark: {
            bgColor: "gray.900",
            _text: {
                color: "white",
            },
        },
        light: {
            bgColor: "white",
            _text: {
                color: "gray.800",
            },
        },
    }), []);
    return isRenderable ? (_jsx(BaseTooltip, Object.assign({}, variants[variant], rest, { isOpen: isOpen }, { children: _jsx(Pressable, Object.assign({ onPress: () => setOpen((ps) => !ps), onHoverIn: () => setOpen(true), onHoverOut: () => setOpen(false) }, { children: children })) }))) : (_jsx(_Fragment, { children: children }));
};
export default ToolTip;
